import { render, staticRenderFns } from "./EditAdministrators.vue?vue&type=template&id=2dd8c603"
import script from "./EditAdministrators.vue?vue&type=script&lang=js"
export * from "./EditAdministrators.vue?vue&type=script&lang=js"
import style0 from "./EditAdministrators.vue?vue&type=style&index=0&id=2dd8c603&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports